module.exports = __webpack_public_path__ + "img/sidebar-block-1.ru.b9a5605a.png";